import { useId } from 'react';

import styles from './Slider.module.css';

export interface SliderProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (next: number) => void;
  low?: string;
  high?: string;
  disabled?: boolean;
  format?: (value: number) => string;
}

export function Slider({
  label,
  value,
  min,
  max,
  step,
  onChange,
  low,
  high,
  disabled,
  format,
}: SliderProps) {
  const id = useId();
  const shown = format ? format(value) : String(value).replace('.', ',');

  return (
    <div className={styles.slider}>
      <div className={styles.head}>
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
        <span className={styles.value}>{shown}</span>
      </div>
      <input
        id={id}
        type="range"
        className={styles.range}
        value={value}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        onChange={(event) => onChange(Number(event.target.value))}
      />
      {(low || high) && (
        <div className={styles.ends}>
          <span>{low}</span>
          <span>{high}</span>
        </div>
      )}
    </div>
  );
}
